/* RESPONSIBLE TEAM: team-automation-foundations */
import FinAiAgentSalesPerformanceRoute from '../sales/performance';

export default class FinAIAgentAnalyzeSalesPerformanceRoute extends FinAiAgentSalesPerformanceRoute {}
